<script>
const ProductCard = require('./ProductCard.vue');
const _debounce = require('lodash/debounce');

module.exports = {
  name: 'ProductList',
  components: {
    ProductCard,
  },
  props: {
    actionLink: {
      type: String,
      default: '', // e.g., see all
    },
    limit: {
      type: Number,
    },
  },
  data() {
    return {
      isTablet: window.innerWidth >= 768,
      visibleCount: 24,
    };
  },
  created() {
    this.debouncedResize = _debounce(this.onResize, 100);
  },
  mounted() {
    window.addEventListener('resize', this.debouncedResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedResize);
  },
  watch: {
    '$store.getters.productResults'() {
      this.visibleCount = 24;
    },
  },
  computed: {
    allProducts() {
      const results = this.$store.getters.productResults;

      if (!Array.isArray(results)) return [];

      return results.map((product, index) => ({
        key: product.productId,
        positionClass: this.getItemPositionClass(index),
        product,
      }));
    },
    gridItems() {
      if (this.limit) {
        return this.allProducts.slice(0, this.limit);
      }

      if (this.actionLink === 'load more') {
        return this.allProducts.slice(0, this.visibleCount);
      }

      return this.allProducts;
    },
    hasMore() {
      return this.visibleCount < this.allProducts.length;
    },
    showNoResults() {
      return this.$store.getters.productResults.length === 0;
    },
  },
  methods: {
    setActiveTab(tab) {
      this.$store.commit('setActiveTab', tab);
    },
    loadMore() {
      this.visibleCount += 24;
    },
    onResize() {
      this.isTablet = window.innerWidth >= 768;
    },
    getItemPositionClass(index) {
      if (this.isTablet) {
        const mod = index % 3;
        if (mod === 0) return 'is-col-left';
        if (mod === 1) return 'is-col-center';
        return 'is-col-right';
      } else {
        return index % 2 === 0 ? 'is-col-left' : 'is-col-right';
      }
    },
  },
};
</script>

<template>
  <div class="product-list">
    <template v-for="(item, index) in gridItems">
      <ProductCard
        :class="item.positionClass"
        :item="item"
        :index="index"
        :key="item.key"
      />
    </template>
    <div class="action-link" v-if="actionLink && !showNoResults">
      <div
        class="see-all-products"
        v-if="actionLink === 'see all'"
        @click="setActiveTab('products')"
      >
        <div class="icon"></div>
        <span class="link">See all products results</span>
      </div>

      <div
        class="see-all-products"
        v-if="actionLink === 'load more' && hasMore"
        @click="loadMore"
      >
        <div class="icon"></div>
        <span class="link">See more product results</span>
      </div>
    </div>
    <div v-show="showNoResults" class="no-results-container">
      <div class="no-results-text">
        <div>Sorry, there are no matching results for this filter + search</div>
        <div>Try a different filter + search ...</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
